"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useCardContextValue", {
    enumerable: true,
    get: function() {
        return useCardContextValue;
    }
});
function useCardContextValue({ selectableA11yProps }) {
    return {
        selectableA11yProps
    };
}
